export default "__VITE_ASSET__BWjrrjUd__"